import React from 'react'

const LinkedinIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_706_52739)">
        <path
          d="M12 0.47998C5.63761 0.47998 0.480011 5.63758 0.480011 12C0.480011 18.3624 5.63761 23.52 12 23.52C18.3624 23.52 23.52 18.3624 23.52 12C23.52 5.63758 18.3624 0.47998 12 0.47998ZM9.18001 16.7748H6.84721V9.26758H9.18001V16.7748ZM7.99921 8.34598C7.26241 8.34598 6.78601 7.82398 6.78601 7.17838C6.78601 6.51958 7.27681 6.01318 8.02921 6.01318C8.78161 6.01318 9.24241 6.51958 9.25681 7.17838C9.25681 7.82398 8.78161 8.34598 7.99921 8.34598ZM17.7 16.7748H15.3672V12.6144C15.3672 11.646 15.0288 10.9884 14.1852 10.9884C13.5408 10.9884 13.158 11.4336 12.9888 11.862C12.9264 12.0144 12.9108 12.2304 12.9108 12.4452V16.7736H10.5768V11.6616C10.5768 10.7244 10.5468 9.94078 10.5156 9.26638H12.5424L12.6492 10.3092H12.696C13.0032 9.81958 13.7556 9.09718 15.0144 9.09718C16.5492 9.09718 17.7 10.1256 17.7 12.336V16.7748Z"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_52739">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LinkedinIcon
